import { saveItem } from "action/shopping-cart/saveItem";
import { VEHICLE_FITMENT } from "constant/shared-constants";
import { RootState } from "interfaces/generics.type";
import { Heart } from "lucide-react";
import { useToast } from "modules/components/toast/ToastContext";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from "./card-actions.module.scss";

function SaveButton({ product = {}, className = "" }: any) {
  const [isSavedItem, setSavedItem] = useState(false);
  const dispatch = useDispatch();
  const { showToast } = useToast();

  const { savedItems } = useSelector((store: RootState) => store.shoppingCart);
  const { selectedVehicle } = useSelector((store: RootState) => store.garage);
  const isThisSavedItem = savedItems.some((item: any) => item.sku === product.sku);

  useEffect(() => {
    setSavedItem(isThisSavedItem);
  }, [savedItems]);

  const callbackAfterSave = () => {
    const message = isThisSavedItem ? "Item is removed from wishlist" : "Item is moved to wishlist";
    showToast({ type: "success", message, iconClass: "fa-check" });
  };

  const handleSaveItemForLater = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    const saveOrRemove = !isSavedItem;
    dispatch(saveItem(
      product,
      selectedVehicle,
      callbackAfterSave,
      saveOrRemove ? product.fitment === VEHICLE_FITMENT.UNIVERSAL : true,
      saveOrRemove ? 1 : 0,
    ));
  };

  const icon = isSavedItem ? <Heart size={14} fill="#f44336" strokeWidth={0} /> : <Heart className={styles.fa_heart} size={14} />;

  return (
    <button type="button" className={`btn ${styles.action_button} ${styles.btn_save} ${className}`} onClick={handleSaveItemForLater}>
      {icon}
    </button>
  );
}

export default SaveButton;
